'use strict';

/** Cadence polling étiquette post-création shipping-order. */
export const LABEL_POLL_INTERVAL_MS = 3000;
export const LABEL_POLL_MAX_DURATION_MS = 30000;

/**
 * Polling borné du statut étiquette (Admin uniquement).
 * @param {object} opts
 * @param {() => Promise<{ status: 'pending'|'available'|'error', terminal?: boolean }>} opts.tick
 * @param {(result: { status: string, reason?: string }) => void} opts.onSettled
 * @returns {{ stop: () => void, started: boolean }}
 */
export function startExpeditionLabelPolling({ tick, onSettled, intervalMs = LABEL_POLL_INTERVAL_MS, maxDurationMs = LABEL_POLL_MAX_DURATION_MS }) {
  let stopped = false;
  let intervalId = null;
  const startedAt = Date.now();

  const stop = (reason, status = 'pending') => {
    if (stopped) return;
    stopped = true;
    if (intervalId != null) {
      clearInterval(intervalId);
      intervalId = null;
    }
    onSettled({ status, reason });
  };

  const runTick = async () => {
    if (stopped) return;
    if (Date.now() - startedAt >= maxDurationMs) {
      stop('timeout', 'pending');
      return;
    }
    try {
      const result = await tick();
      if (result?.status === 'available') {
        stop('available', 'available');
        return;
      }
      if (result?.status === 'error' && result.terminal) {
        stop('error', 'error');
      }
    } catch {
      stop('error', 'error');
    }
  };

  intervalId = setInterval(() => {
    void runTick();
  }, intervalMs);

  void runTick();

  return {
    stop: () => stop('manual', 'pending'),
    get stopped() {
      return stopped;
    },
  };
}
